import { useEffect, useReducer, useContext } from 'react';
import { Context } from '../../components/Store';
import { useLocation, useParams, useNavigate, Link } from 'react-router-dom';
import ModalWhereToBuy from '../../components/ModalWhereToBuy';
import { Helmet } from 'react-helmet';
import {
    canonicalUrl,
    toMetaDescription,
    productJsonLd,
} from '../../utilities/seo';
import { useFetch } from '../../utilities/hooks';
import {
    Breadcrumbs,
    NavigationProducts,
    Preloader,
    RelatedRecipesFromRecipes,
} from '../../components';
import NotFound from '../NotFound';
import './styles.scss';

const Products = () => {
    const {
        state: { modalWhereToBuyIsOpen, storesModalProducts },
        dispatch: setModalWhereToBuyIsOpen,
    } = useContext(Context);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const { pathname } = useLocation();
    const { slug } = useParams();
    const navigate = useNavigate();
    const { data } = useFetch(`${BASE_URL}/api/products_en`);
    const [state, dispatch] = useReducer(
        (state, action) => {
            return { ...state, ...action };
        },
        {
            product: {},
            mouseOver: false,
            selectedTab: 'ingredients',
        }
    );

    // Los slugs heredados mezclan mayúsculas; se acepta cualquier variante y se corrige la URL.
    const product = slug
        ? data?.products.find(
              el => el.slug.toLowerCase() === slug.toLowerCase()
          )
        : data?.product;
    const isNotFound = Boolean(data && slug && !product);

    const changeImageProduct = () => {
        dispatch({ mouseOver: !state.mouseOver });
    };
    useEffect(() => {
        if (!product) return;
        if (slug && product.slug !== slug) {
            navigate(`/products/${product.slug}`, { replace: true });
            return;
        }
        dispatch({ product });
    }, [pathname, data]);

    const openModal = () => {
        setModalWhereToBuyIsOpen({ modalWhereToBuyIsOpen: true });
    };

    if (isNotFound) return <NotFound />;

    return (
        <>
       
            {data ? (
                <section id='productsSection'>                    
                    <Helmet>
                        <meta charSet='utf-8' />
                        {slug && product?.title ? (
                            <title>{`${product.title} | Isadora Beans`}</title>
                        ) : (
                            <title>Products | Isadora Beans Refried Beans and Whole Beans</title>
                        )}
                        <meta
                            name='description'
                            content={
                                slug && product?.details
                                    ? toMetaDescription(product.details)
                                    : 'Explore Isadora Beans products, including refried beans and whole beans in a pouch, inspired by authentic Mexican flavor.'
                            }
                        />
                        <link rel='canonical' href={canonicalUrl()} />
                        {slug && product?.title && (
                            <script type='application/ld+json'>
                                {JSON.stringify(productJsonLd(product, BASE_URL))}
                            </script>
                        )}
                        <style type='text/css'>
                        {`
                            .sr-only {
                                position: absolute;
                                width: 1px;
                                height: 1px;
                                padding: 0;
                                margin: -1px;
                                overflow: hidden;
                                clip: rect(0, 0, 0, 0);
                                white-space: nowrap;
                                border-width: 0;
                            }
                        `}
                        </style>
                    </Helmet>
                    <div className='container pt-4'>
                        <Breadcrumbs
                            items={
                                slug && product?.title
                                    ? [
                                          { label: 'Products', path: '/products' },
                                          { label: product.title },
                                      ]
                                    : [{ label: 'Products' }]
                            }
                        />
                    </div>
                    <NavigationProducts products={data.products} />
                    
                    <h1 className="sr-only">
                        {slug && product?.title ? product.title : 'Products'}
                    </h1>
                    <div className='container py-6'>
                        <div
                            className='row d-flex justify-content-center px-md-4'
                            id='main-product-row'
                        >
                            <div
                                id='col-text'
                                className='col-12 col-sm-12 col-md-7'
                            >
                                <div>
                                    <h4
                                        className='productTitle'
                                        dangerouslySetInnerHTML={{
                                            __html: state.product
                                                .formated_title,
                                        }}
                                    ></h4>
                                    <p className='productDescription font-gotham-bold'
                                        dangerouslySetInnerHTML={{__html: state.product.details}}></p>
                                    <div className='ingredients-nutrition-cont'>
                                        <div className='d-flex justify-content-center mb-4'>
                                            {[
                                                'ingredients',
                                                'nutrition facts',
                                            ].map((el, i) => (
                                                <button
                                                    key={i}
                                                    className={`selectors${
                                                        state.selectedTab === el
                                                            ? ' active'
                                                            : ''
                                                    }`}
                                                    onClick={dispatch.bind(
                                                        null,
                                                        {
                                                            selectedTab: el,
                                                        }
                                                    )}
                                                >
                                                    {el}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        {state.selectedTab === 'ingredients' ? (
                                            <div>
                                                <p className='productDescription font-gotham-bold'>
                                                    INGREDIENTS:{' '}
                                                    {state.product.ingredients}
                                                </p>
                                            </div>
                                        ) : (
                                            <div className='row'>
                                                <img
                                                    src={
                                                        BASE_URL +
                                                        '/storage/' +
                                                        state.product
                                                            .nutricional_details
                                                    }
                                                    className='nutritionalImg mx-auto'
                                                    alt={
                                                        state.product.title +
                                                        ' Nutritional Image'
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className='container'>
                                        <div className='au-deco-line mx-auto my-3'></div>
                                        <div className='row my-3'>
                                            <Link
                                                to={
                                                    '/recipes/' +
                                                    state.product.slug
                                                }
                                                className='btn btn-primary custom-brown-color'
                                            >
                                                LETS COOK
                                            </Link>                                            
                                        </div>
                                        {storesModalProducts[state.product.slug]
                                            ?.length > 0 && (
                                            <>
                                                <div className='row'>
                                                    <button
                                                        className='btn btn-primary custom-brown-color'
                                                        onClick={() =>
                                                            openModal()
                                                        }
                                                    >
                                                        BUY NOW
                                                    </button>
                                                </div>
                                                {modalWhereToBuyIsOpen && (
                                                    <ModalWhereToBuy
                                                        OpenClose
                                                        Position
                                                        productsSlug={
                                                            state.product.slug
                                                        }
                                                    />
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-sm-12 col-md-5'>
                                <div>
                                    <img
                                        src={
                                            !state.mouseOver
                                                ? BASE_URL +
                                                  '/storage/' +
                                                  state.product.active_image
                                                : BASE_URL +
                                                  '/storage/' +
                                                  state.product.backside_imagen
                                        }
                                        alt={`Isadora ${state.product?.title} pouch`}
                                        className='productImage img-fluid'
                                        onMouseOver={changeImageProduct}
                                        onMouseLeave={changeImageProduct}
                                        id='frontProductImg'
                                        fetchpriority='high'
                                        // Todas las fotos de producto de la API miden 500×687: con las
                                        // dimensiones el navegador reserva el espacio y nada salta (CLS).
                                        width='500'
                                        height='687'
                                    />
                                    <div className='row d-flex justify-content-center hoverInstructions'>
                                        Hover over the image to see the reverse
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                <Preloader fullPage />
            )}
            {/* Solo con el producto cargado: antes se dibujaba vacía arriba y luego bajaba (CLS). */}
            {data && state.product?.id && (
                <section id='related-recipes-sec' className='py-5'>
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className='d-flex flex-column align-items-center'>
                                <h2 className='text-white text-center mb-5'>
                                    <span className='font-bernierd text-lowercase'>
                                        Recipes Prepared With
                                    </span>
                                    <br></br>
                                    <span className='font-kellog'>
                                        {state.product.title}
                                    </span>
                                </h2>
                            </div>
                        </div>
                        <RelatedRecipesFromRecipes productId={state.product.id} />
                    </div>
                </section>
            )}
        </>
    );
};

export default Products;
